/**
 * A js file containing exports that define color swatches.
 * @object
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */
export var colors = {
  white: '#ffffff',
  grayBlack: '#202224',
  black: '#000000',
  grayLight: '#ecefef',
  grayMid: '#60686d',
  cobalt: '#627691',
  cobaltHover: '#495b72',
  ocean: '#649ab2',
  oceanHover: '#4c809a',
  aqua: '#45a57c',
  aquaHover: '#368161',
  plum: '#977f96',
  plumHover: '#7d5c7d',
  charcoalDefault: '#42484d',
  charcoalHover: '#272d33',
  chocolateDefault: '#846550',
  chocolateHover: '#6b4c37',
  graphiteDefault: '#827771',
  graphiteHover: '#695951',
  slateDefault: '#61686e',
  slateHover: '#424c54',
  error: '#cf8154',
  required: '#ba4534'
};
export var iconColors = {
  // Icon Colors
  // Ocean Blue
  iconBlue: '#6599b3',
  // Obsidian
  iconDark: '#1b1d20',
  iconGreen: colors.aqua,
  iconLight: colors.white,
  // CTA Link
  iconLink: '#3380a7'
};